<div class="bg-white border rounded-xl overflow-hidden"
  [class.border-amber-300]="foreignRights().length > 0" [class.border-slate-200]="foreignRights().length === 0">

  <!-- Cap header -->
  <div class="px-4 py-3 border-b border-slate-100 flex flex-wrap items-center justify-between gap-2">
    <div class="flex items-center gap-2 min-w-0">
      <mat-icon class="text-slate-500">directions_car</mat-icon>
      <div class="min-w-0">
        <div class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Car limit</div>
        @if (loadingUsage()) {
        <div class="text-sm text-slate-400">Loading…</div>
        } @else if (usage(); as u) {
        <div class="text-sm font-bold text-slate-900 truncate">{{ u.ownerName || u.name }}</div>
        } @else {
        <div class="text-sm text-slate-500">Car limit could not be loaded</div>
        }
      </div>
    </div>
    @if (usage(); as u) {
    <span class="text-[11px] px-2 py-0.5 rounded-full font-semibold bg-blue-50 text-blue-700 border border-blue-200">
      Max {{ u.maxCarsAllowed }} inside
    </span>
    }
  </div>

  @if (usage(); as u) {
  <div class="px-4 py-3 space-y-2 text-xs border-b border-slate-100">
    @if (foreignRights().length > 0) {
    <div class="flex items-start gap-1.5 text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2">
      <mat-icon class="text-sm text-amber-600">warning</mat-icon>
      <span>
        Shared with
        @for (r of foreignRights(); track r.parkingRightId; let last = $last) {
        <strong>{{ r.ownerName || 'no owner' }}</strong>{{ r.comment ? ' (' + r.comment + ')' : '' }}{{ last ? '' : ', ' }}
        }
      </span>
    </div>
    }

    <div class="flex flex-wrap items-center gap-1">
      <span class="text-[10px] text-slate-500 font-medium mr-1">Rights:</span>
      @for (r of u.rights ?? []; track r.parkingRightId) {
      <span class="px-1.5 py-0.5 rounded text-[10px] font-medium border"
        [class]="r.ownedByPoolOwner ? 'bg-slate-50 text-slate-700 border-slate-200' : 'bg-amber-50 text-amber-800 border-amber-200'">
        {{ r.name || r.comment || 'Parking Right' }} · {{ r.ownerName || 'no owner' }}
      </span>
      }
    </div>
  </div>
  }

  <!-- Occupancy -->
  <div class="px-4 py-3 space-y-3">
    @if (overflowCount() > 0) {
    <div class="text-right text-[11px] font-semibold text-amber-700">{{ overflowCount() }} pool-full stay(s)</div>
    }

    @if (loadingTimeline()) {
    <div class="py-6 flex justify-center"><mat-spinner diameter="24"></mat-spinner></div>
    } @else if (timelineFailed()) {
    <p class="text-xs text-slate-500">Stays could not be loaded.</p>
    } @else if (events().length === 0) {
    <p class="text-xs text-slate-500">No stays in the last 30 days.</p>
    } @else {
    <jjames-timeline-chart [events]="events()" [capacity]="usage()?.maxCarsAllowed ?? 1"
      [windowStart]="windowStart()" [windowEnd]="windowEnd()" />
    @if (truncated()) {
    <p class="text-[11px] text-amber-600">Showing the first 500 stays only.</p>
    }
    }
  </div>
</div>
